var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type == 'cn')?_c('activity-chinese',{attrs:{"id":_vm.msgId}}):_c('activity-english',{attrs:{"id":_vm.msgId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }